// extracted by mini-css-extract-plugin
module.exports = {"con":"SingleProduct_con__53IRZ"};